import { atom } from "recoil";

import { keysOfRecoil } from "store/recoil/keys";

export const pageTitleState = atom<string>({
  key: keysOfRecoil.PAGE_TITLE,
  default: "",
});
